import React, { lazy, useEffect, Suspense } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "./App.css";
import { useCookies } from "react-cookie";


const Dashboard = lazy(() => import("./components/Dashboard/index"));
const Analytics = lazy(() => import("./components/Analytics/index"));
const SiteAi = lazy(() => import("./components/SiteAi/index"));
const Login = lazy(() => import("./components/Login/index"));
// const HomeMain = lazy(() => import("./components/HomeMain/homeMain"));
// const Alerts = lazy(() => import("./components/Alerts/alerts"));

function App() {
  const [cookies] = useCookies(["auth_token"]);

  useEffect(() => {
    if (!cookies.auth_token && !window.location.pathname.includes("/login")) {
      window.location.href = "/login";
    }
  }, [cookies]);

  return (
    <div className="App">
      <Router>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="/login" element={<Login />} />
            {/* <Route path="/homeMain" element={<HomeMain />} /> */}
            <Route path="/dashboard" element={<Dashboard />} />
            {/* <Route path="/alerts" element={<Alerts />} /> */}
            <Route path="/siteAI" element={<SiteAi />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </Suspense>
      </Router>
    </div>
  );
}

export default App;
